import { Cog, X } from 'lucide-react';

import { cn } from '@/utils/cn';

import { usePhaseBanner } from './phase-banner-store';

type PhaseBannerProps = {
  phase: 'PROD' | 'BETA' | 'ALPHA';
};

const PhaseBanner = ({ phase }: PhaseBannerProps) => {
  const { show, setShow } = usePhaseBanner();
  const onClose = () => {
    setShow(false);
  };

  const animationCn =
    phase !== 'PROD' && show
      ? ['opacity-100']
      : ['opacity-0', '-translate-y-8', 'fixed'];
  const colors =
    phase === 'BETA'
      ? {
          backgroundCn: 'bg-sky-100',
          textCn: 'text-sky-700',
          buttonCn: 'hover:bg-sky-200 focus:ring-sky-300',
        }
      : {
          backgroundCn: 'bg-emerald-100',
          textCn: 'text-emerald-700',
          buttonCn: 'hover:bg-emerald-200 focus:ring-emerald-300',
        };

  return (
    <div
      className={cn(
        animationCn,
        colors.backgroundCn,
        colors.textCn,
        'w-full',
        'drop-shadow-md',
        'transition-all',
        'duration-500',
      )}
    >
      <div className="mx-auto h-full max-w-7xl">
        <div className="flex size-full flex-row items-center justify-between py-2">
          <Cog className="h-8 w-24" />
          <div className="flex grow flex-col">
            <p className="text-sm md:text-base">
              You are viewing the{' '}
              <span className="text-base font-bold underline md:text-lg">
                {phase}
              </span>{' '}
              version of GlyTouCan.
            </p>
            <p className="text-xs md:text-sm">
              You can now browse the official version at{' '}
              <a
                className="underline transition-all duration-200 hover:font-bold focus:ring-2"
                href="https://glytoucan.org"
              >
                https://glytoucan.org
              </a>
              .
            </p>
          </div>
          <div className="h-8 w-24">
            <button
              className={cn(
                colors.buttonCn,
                'size-7',
                ['transition-all', 'duration-200'],
                ['rounded-full', 'focus:ring-2'],
                ['flex', 'flex-col', 'justify-center', 'items-center'],
              )}
              onClick={onClose}
            >
              <X className="size-6" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

PhaseBanner.displayName = 'PhaseBanner';

export { PhaseBanner };
